import { useRouteMatch } from 'react-router';
import { CustomHomepageById } from '../custom-homepage';

export const CustomHomepagePreview = () => {
  const {
    params: { homepageId },
  } = useRouteMatch<{ homepageId: string }>();

  return <CustomHomepageById homepageId={homepageId} isPreviewMode={true} />;
};
